import { useState, useEffect } from "react";
import { getSectionById } from "../api/sections/sectionRequest";

export const useSectionDetails = (sectionId) => {
  const [sectionDetails, setSectionDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!sectionId) return;

    const fetchZoneDetails = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getSectionById(sectionId);
        setSectionDetails(data);
      } catch (err) {
        setError(
          err.response?.data?.message || "Failed to fetch section details"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchZoneDetails();
  }, [sectionId]);

  return { sectionDetails, loading, error };
};
